'use client';

import styles from '../shop.module.css';

export default function MobileFilterBar({ filterRef, filterHoverStyle, activeFilter, onFilterClick }) {
  return (
    <div className={styles.mobileFilterBar}>
      <div className={styles.filterContainer} ref={filterRef}>
        <div
          className={styles.filterIndicator}
          style={{
            transform: filterHoverStyle.transform,
            width: filterHoverStyle.width,
            opacity: filterHoverStyle.opacity,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
        />
        <button
          className={`${styles.filterBtn} ${activeFilter === 0 ? styles.active : ''}`}
          onClick={() => onFilterClick(0)}
        >
          Category
        </button>

        <button
          className={`${styles.filterBtn} ${activeFilter === 2 ? styles.active : ''}`}
          onClick={() => onFilterClick(2)}
        >
          Rating
        </button>
      </div>
    </div>
  );
}
